
import { LoadingOutlined } from '@ant-design/icons'
import React, { useEffect, } from "react";

import ExerciseCardDataCoding from "./exercise-card-data-coding";
import ExerciseCardSingleSelect from "./exercise-card-single-select";
import ExerciseCardMultiSelect from "./exercise-card-multi-select";
import ExerciseCardSort from "./exercise-card-sort";
import ExerciseCardSubjective from "./exercise-card-subjecitive";



export interface Props {exercise:any,
    renderType:string, //渲染的主题类型，"dark","white"
    teacherOnly:boolean,  // 仅老师
    editorMode:boolean,//是否可编辑模式，
    showAnser:boolean,//是否默认显示答案
    showClean:boolean,//是否显示清除按钮
  }

export const ExerciseCard: React.FC<Props> = (props) => {

    const {exercise,renderType,teacherOnly,editorMode,showAnser,showClean} = props

    const refresh_table_tds = ()=>{
        setTimeout(function(){
          const table_tds = document.getElementsByTagName("td") //以下代码设置页面表格内容属性
          //console.log(table_tds)
          for(let i=0; i < table_tds.length;  i++){
              try{
                console.log(table_tds[i].innerText)
                table_tds[i].setAttribute('title', table_tds[i].innerText);
              }catch(error1){
                console.log(error1)
              }
            }
    
            const table_ths = document.getElementsByTagName("th") //以下代码设置页面表格内容属性
            //console.log(table_tds)
            for(let j=0; j < table_ths.length;  j++){
                try{
                  //console.log(table_tds[i].innerText)
                  table_ths[j].setAttribute('title', table_ths[j].innerText);
                }catch(error2){
                  console.log(error2)
                }
              }
        }, 1000); //单位是毫秒
    
      }

    useEffect(()=>{
    /*window.onload = function(){
      try{
        refresh_table_tds()
      }catch(error){
        console.log(error)
      }
    } */
    },[])
   

    switch(exercise?.type){
        case 1 : //数据实操题
           return  <ExerciseCardDataCoding exercise={exercise} renderType = {renderType} teacherOnly={teacherOnly} editorMode={editorMode} showAnser={showAnser} showClean={showClean}/>
           
        case 2: //单选题
           
           return <ExerciseCardSingleSelect exercise={exercise} renderType = {renderType} teacherOnly={teacherOnly} editorMode={editorMode} showAnser={showAnser} />
      
        case 3 ://多选题
            return   <ExerciseCardMultiSelect exercise={exercise} renderType = {renderType} teacherOnly={teacherOnly} editorMode={editorMode} showAnser={showAnser}/>
            
        case 4: //排序题
            return  <ExerciseCardSort exercise={exercise} renderType = {renderType} teacherOnly={teacherOnly} editorMode={editorMode} showAnser={showAnser}/>

        case 5: //主观题
            return <ExerciseCardSubjective exercise={exercise} renderType = {renderType} teacherOnly={teacherOnly} editorMode={editorMode} showAnser={showAnser}/>
        default :
            return (
            <div style={{textAlign:"center"}}>
                <LoadingOutlined />
            </div>
            )
    }


}

export default ExerciseCard